import React, { forwardRef } from 'react';
import { SvgIcon, SvgIconProps } from '@mui/material';

/**
 * Flow brand exclusive icon
 */
export const BuildingFilledIcon: React.FC<SvgIconProps> = forwardRef((props, ref) => {
  return (
    <SvgIcon viewBox="2 2 20 20" ref={ref} {...props}>
      <path
        fillRule="evenodd"
        d="M5.76685 3.1001H18.2335V19.1001H20V20.9001H4V19.1001H5.76685V3.1001ZM11 6.66675H9V8.66675H11V6.66675ZM9 10.6667H11V12.6667H9V10.6667ZM11 14.6667H9V16.6667H11V14.6667ZM13 6.66667H15V8.66667H13V6.66667ZM15 10.6667H13V12.6667H15V10.6667ZM13 14.6667H15V16.6667H13V14.6667Z"
      />
    </SvgIcon>
  );
});
